// Carry the CHA2DS2-VASc factors and QRisk3 conditions of a patient's most
// recent completed CDM review forward into their next review, so morbidities the
// GP already recorded pre-seed the calculators instead of starting blank.
//
// The API is the source of truth (KIN-1261): the BE round-trips
// cha2ds2vascFactors and qRisk3Conditions on the CDM review DTO (see useSendCDM
// payload / useGetCDM `transformCDMDataFromAPI`), so a new review is pre-seeded
// from the prior review fetched via the API (CDMItemForm → RiskAndAssessmentForm).
// This per-patient localStorage snapshot is a FALLBACK only — it keeps
// carry-forward working offline and for reviews created before the round-trip.

const buildKey = (patientId) => `kinesin-cdm-morbidities-${patientId}`;

const isNonEmptyObject = (value) =>
  !!value && typeof value === "object" && Object.keys(value).length > 0;

export const readCdmMorbidityCarryForward = (patientId) => {
  if (!patientId) return {};

  try {
    const raw = localStorage.getItem(buildKey(patientId));

    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

export const writeCdmMorbidityCarryForward = (
  patientId,
  { cha2ds2vascScore, cha2ds2vascFactors, qRisk3Conditions }
) => {
  if (!patientId) return;

  const snapshot = {};

  if (cha2ds2vascScore !== "" && cha2ds2vascScore !== null && cha2ds2vascScore !== undefined) {
    snapshot.cha2ds2vascScore = cha2ds2vascScore;
  }

  if (isNonEmptyObject(cha2ds2vascFactors)) {
    snapshot.cha2ds2vascFactors = cha2ds2vascFactors;
  }

  if (isNonEmptyObject(qRisk3Conditions)) {
    snapshot.qRisk3Conditions = qRisk3Conditions;
  }

  // Nothing worth carrying forward — leave any previous snapshot untouched.
  if (!isNonEmptyObject(snapshot)) return;

  try {
    localStorage.setItem(buildKey(patientId), JSON.stringify(snapshot));
  } catch {
    // localStorage unavailable/full — carry-forward is a convenience, not
    // load-bearing, so failing silently is acceptable here.
  }
};
